// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-backround[data-v-3ca30915]{background-color:rgba(131,125,137,.15)}.make-branded[data-v-3ca30915]{color:#4abca5}", ""]);
// Exports
module.exports = exports;
